import { render } from "./subMenu.vue?vue&type=template&id=1201e197&scoped=true"
import script from "./subMenu.vue?vue&type=script&lang=js"
export * from "./subMenu.vue?vue&type=script&lang=js"

import "./subMenu.vue?vue&type=style&index=0&id=1201e197&lang=scss&scoped=true"

import exportComponent from "/home/code/aiyu-before-pc/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1201e197"]])

export default __exports__